import { mergeObjectTypes } from '../cacheHelpers';

const PurchaseOrderLotsDateType = {
  merge: mergeObjectTypes
};

export default PurchaseOrderLotsDateType;
